var _path, _path2, _path3, _circle, _path4, _path5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path6, _path7, _path8, _rect, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectifiedPetitionFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03033 4.03033L3.0507 4.00996L3.06944 3.98809L5.4708 1.18651C5.70828 0.909453 6.05496 0.75 6.41987 0.75H21.4909C22.1813 0.75 22.7409 1.30964 22.7409 2V28.9091C22.7409 29.5994 22.1813 30.1591 21.4909 30.1591H2C1.30964 30.1591 0.75 29.5994 0.75 28.9091V6.82843C0.75 6.49691 0.881696 6.17896 1.11612 5.94454L3.03033 4.03033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03033 4.03033L3.0507 4.00996L3.06944 3.98809L5.4708 1.18651C5.70828 0.909453 6.05496 0.75 6.41987 0.75H21.4909C22.1813 0.75 22.7409 1.30964 22.7409 2V28.9091C22.7409 29.5994 22.1813 30.1591 21.4909 30.1591H2C1.30964 30.1591 0.75 29.5994 0.75 28.9091V6.82843C0.75 6.49691 0.881696 6.17896 1.11612 5.94454L3.03033 4.03033Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03033 4.03033L3.0507 4.00996L3.06944 3.98809L5.4708 1.18651C5.70828 0.909453 6.05496 0.75 6.41987 0.75H21.4909C22.1813 0.75 22.7409 1.30964 22.7409 2V28.9091C22.7409 29.5994 22.1813 30.1591 21.4909 30.1591H2C1.30964 30.1591 0.75 29.5994 0.75 28.9091V6.82843C0.75 6.49691 0.881696 6.17896 1.11612 5.94454L3.03033 4.03033Z",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 6.5,
    r: 4,
    stroke: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7017 6.73291H15.7959V6.16162H16.7017C16.8416 6.16162 16.9556 6.13883 17.0435 6.09326C17.1313 6.04606 17.1956 5.98096 17.2363 5.89795C17.277 5.81494 17.2974 5.72135 17.2974 5.61719C17.2974 5.51139 17.277 5.41292 17.2363 5.32178C17.1956 5.23063 17.1313 5.15739 17.0435 5.10205C16.9556 5.04671 16.8416 5.01904 16.7017 5.01904H16.0498V8H15.3174V4.44531H16.7017C16.98 4.44531 17.2184 4.49577 17.417 4.59668C17.6172 4.69596 17.7702 4.8335 17.876 5.00928C17.9818 5.18506 18.0347 5.38607 18.0347 5.6123C18.0347 5.8418 17.9818 6.04036 17.876 6.20801C17.7702 6.37565 17.6172 6.50505 17.417 6.59619C17.2184 6.68734 16.98 6.73291 16.7017 6.73291Z",
    fill: "#717070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C6 1 6 3.83333 6 4C6 4.16667 6 5 5.44444 5.5C5 5.9 4.51852 6 4.33333 6C4.14815 6 1 6 1 6",
    stroke: "#717070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8.5,
    x2: 11,
    y2: 8.5,
    stroke: "#717070"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11.5,
    x2: 13,
    y2: 11.5,
    stroke: "#717070"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 26.5,
    x2: 19,
    y2: 26.5,
    stroke: "#717070"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 14.5,
    x2: 19,
    y2: 14.5,
    stroke: "#717070"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 17.5,
    x2: 19,
    y2: 17.5,
    stroke: "#717070"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20.5,
    x2: 19,
    y2: 20.5,
    stroke: "#717070"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 23.5,
    x2: 19,
    y2: 23.5,
    stroke: "#717070"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9437 13.5211C8.22513 11.5483 5.75448 10.9049 4.16493 12.2766L3.74396 12.6398C2.8751 13.3896 2.51011 14.5694 2.80378 15.6788L3.21442 17.2301C3.38763 17.8845 3.77706 18.461 4.3194 18.8661L5.1547 19.4899C5.63343 19.8475 5.99449 20.3398 6.19161 20.9039L8.34086 27.054C8.73738 28.1887 9.86017 28.9034 11.056 28.7825C12.7421 28.612 13.8167 26.8994 13.2367 25.307L8.9437 13.5211Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6787 13.6501C7.40281 12.9112 6.58018 12.5359 5.84132 12.8118C5.10245 13.0877 4.72714 13.9103 5.00303 14.6492L6.48531 18.6189L9.16097 17.6198L7.6787 13.6501Z",
    fill: "white",
    stroke: "#717070"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84012 26.8175C9.89834 26.9735 9.98964 27.1149 10.1077 27.2322C10.8061 27.9258 11.9965 27.4813 12.0694 26.4997C12.0817 26.3338 12.0579 26.1671 11.9997 26.0111L11.5839 24.8976L9.4243 25.7039L9.84012 26.8175Z",
    fill: "white",
    stroke: "#717070"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.293506,
    y: 0.643315,
    width: 2.30524,
    height: 6.17816,
    transform: "matrix(-0.936821 0.349809 0.349809 0.936821 8.75337 18.1526)",
    fill: "white",
    stroke: "#717070"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 27.7141L11.765 28.6748",
    stroke: "#717070",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65787 14.3622C4.48218 14.1541 4.3753 13.9204 3.96245 14.0745C3.54959 14.2287 3.60809 14.7003 3.71541 14.9877C3.89477 15.4681 4.42184 16.0922 4.78055 17.0529C5.01969 17.6933 5.30508 18.7726 4.89223 18.9267C4.47937 19.0809 4.25659 18.7992 4.1968 18.6391",
    stroke: "#717070",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectifiedPetitionFile);
export default __webpack_public_path__ + "static/media/rectified-petition-file.68baba4b399c32cf17c5b2dac32650ed.svg";
export { ForwardRef as ReactComponent };